/**
 * 
 */

import 'shared/blueprint'
import 'shared/blueprintLegacyNamespace'
import 'shared/galaTypography'

import { FocusStyleManager } from '@blueprintjs/core'
FocusStyleManager.onlyShowFocusOnTabs()
